import { withInstall } from '@mts-fe/utils';
import _AsyncImportBtn from './src/AsyncImportBtn.vue';
import _ModalImportBtn from './src/ModalImportBtn.vue';
import _SyncImportBtn from './src/SyncImportBtn.vue';

export * from './src/types';
export const ModalImportBtn = withInstall(_ModalImportBtn);
export const AsyncImportBtn = withInstall(_AsyncImportBtn);
export const SyncImportBtn = withInstall(_SyncImportBtn);
